export default __webpack_public_path__ + "static/media/labra-darkblue.a1ca846c.svg";